import { render, staticRenderFns } from "./AccidentReviewIndex.vue?vue&type=template&id=37f29d72&scoped=true"
import script from "./AccidentReviewIndex.vue?vue&type=script&lang=js"
export * from "./AccidentReviewIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f29d72",
  null
  
)

export default component.exports